import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect to your New Jersey Devils account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for the games.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your New Jersey Devils{" "}
        <Link
          href={"https://am.ticketmaster.com/devils/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Account Manager
        </Link>{" "}
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How do the New Jersey Devils Pick'Em Plan work?",
    description:
      "The New Jersey Devils Pick'Em Plan lets you fully customize your experience. You choose any home games that best fit your schedule and select any available seats for each game—giving you flexibility and control over your season.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description:
      "Event tickets are delivered directly within your New Jersey Devils Account Manager.",
  },
  {
    title: "What do the 14 Game Plan Benefits Include?",
    description: (
      <>
        Plan Holder benefits include:
        <ul>
          <li>Access to an Exclusive Event</li>
          <li>10% Team Store Discount</li>
          <li>
            Access to Rewards Program which includes B&R Eats, a specially
            priced food and beverage menu for our most loyal fans!
          </li>
        </ul>
      </>
    ),
  },
];

export const DevilsCheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const DevilsRegistrationTerms = () => (
  <>
    By checking this box you agree to receive notifications and offers from the
    New Jersey Devils and to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);
